import MicroModal from "micromodal";
import Shepherd from 'shepherd.js';
import {offset} from '@floating-ui/dom/dist/floating-ui.dom.umd';
import router from "./router";
import {config} from "./config";
import {layers, map} from "./common";
import * as L from "leaflet/dist/leaflet";

export function toggleAccountSpots(btn) {
  if (btn.classList.contains('expanded')) {
    btn.nextElementSibling.classList.add('hidden');
    btn.classList.remove('expanded');
  } else {
    btn.nextElementSibling.classList.remove('hidden');
    btn.classList.add('expanded');
  }
}

export function showSpot(btn, spotIndex) {
  toggleAccountSpots(document.querySelector("#account_spots > button:first-child"));
  loadUserSpot(spotIndex, false);
}

export function configureSpots() {
  toggleAccountSpots(document.querySelector("#account_spots > button:first-child"));
  MicroModal.show('spots_modal', {disableScroll: true});
}

export function configureSpot(spotIndex) {
  MicroModal.close('spots_modal');
  loadUserSpot(spotIndex, true);
}

export function getUserSpot(spotRef) {
  const userProfile = getUserProfile();
  return userProfile.spots.find(s => s.ref === spotRef);
}

export function displayEditControls(spotRef) {
  document.querySelector("#edit_spot_modal_title").innerHTML = `Configuration du spot ${spotRef}`;
  MicroModal.show('edit_spot_modal', {disableScroll: true});
  const editControls = document.querySelector("#edit_spot_controls");
  editControls.classList.remove('hidden');
  editControls.querySelector("#edit_spot_ref").value = spotRef;
  editControls.setAttribute("data-spot", spotRef);
}

export function selectPinnedElements(userSpot) {
  console.debug('selectPinnedElements: ' + JSON.stringify(userSpot));
  if (userSpot.pois.length) {
    for (const poi of document.querySelectorAll(`${userSpot.pois.map(p => "#poi_" + p + ".weather_poi").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
  if (userSpot.webcams.length) {
    for (const poi of document.querySelectorAll(`${userSpot.webcams.map(w => ".webcam_spot a[data-href='" + w + "']").join(',')}`)) {
      poi.closest("g[data-edit]").classList.add("edit_pinned");
    }
  }
  if (userSpot.tideGauges.length) {
    for (const poi of document.querySelectorAll(`${userSpot.tideGauges.map(t => ".tide_spot a[data-href='" + t + "']").join(',')}`)) {
      poi.closest("g[data-edit]").classList.add("edit_pinned");
    }
  }
  if (userSpot.windSensors.length) {
    for (const poi of document.querySelectorAll(`${userSpot.windSensors.map(s => "#sensor_" + s + ".wind_sensor").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
  if (userSpot.wavesSensors.length) {
    for (const poi of document.querySelectorAll(`${userSpot.wavesSensors.map(s => "#sensor_" + s + ".wave_sensor").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
  if (userSpot.tempSensors.length) {
    for (const poi of document.querySelectorAll(`${userSpot.tempSensors.map(s => "#sensor_" + s + ".temp_sensor").join(',')}`)) {
      poi.classList.add("edit_pinned");
    }
  }
}

export function saveCurrentSpot() {
  const userProfile = getUserProfile(), prevSpotRef = document.querySelector("#edit_spot_controls").getAttribute('data-spot'),
    newSpotRef = document.querySelector("#edit_spot_ref").value;
  userProfile.spots[userProfile.spots.findIndex(s => s.ref === prevSpotRef)] = {
    ref: newSpotRef,
    mapCenter: [map.instance.getCenter().lat, map.instance.getCenter().lng],
    mapZoom: map.instance.getZoom(),
    dataLayers: [...layers.dataLayers],
    bgLayers: Array.from(document.querySelectorAll(".map_layer.active")).map(l => l.getAttribute('data-bg')),
    point: map.currentFocus ? [map.currentFocus.lat, map.currentFocus.lng] : null,
    pois: pinnedElements('.weather_poi'),
    webcams: pinnedElements('.webcam_spot'),
    tideGauges: pinnedElements('.tide_spot'),
    windSensors: pinnedElements('.wind_sensor'),
    wavesSensors: pinnedElements('.wave_sensor'),
    tempSensors: pinnedElements('.temp_sensor')
  };
  saveUserProfile(userProfile);
  router.navigate(`/profil/test-wind/spots/${newSpotRef}`);
  document.querySelector("#info_spot_modal_title").innerHTML = `Spot ${newSpotRef} - Enregistrement réussi`;
  document.querySelector("#info_spot_modal_content").innerHTML = `L'enregistrement du spot ${newSpotRef} a bien été effectué. ` +
    `Vous pouvez désormais accéder à ce spot via le menu "mes spots" en entête du site. ` +
    `Vous pouvez également accéder directement au spot via l'adresse <a href="${window.location.protocol}//${window.location.host}/profil/test-wind/spots/${newSpotRef}">${window.location.host}/profil/test-wind/spots/${newSpotRef}</a>`;
  MicroModal.show('info_spot_modal', {disableScroll: true});
}

export function cancelEditSpot() {
  if (window.confirm("Annuler la configuration du spot en cours ?")) {
    const spotRef = document.querySelector("#edit_spot_controls").getAttribute('data-spot');
    router.navigate(`/profil/test-wind/spots/${spotRef}`);
  }
}

export function createMockAccount() {
  const signUpForm = document.querySelector("#wm_sign_up_form");
  if (signUpForm.reportValidity()) {
    MicroModal.close('form_modal');
    document.querySelector("#info_spot_modal_title").innerHTML = `Création de compte réussie`;
    document.querySelector("#info_spot_modal_content").innerHTML = `<p>Merci pour votre saisie, votre compte windfrance a bien été créé.<br/>` +
      `<strong>MODE TEST<br/>Pour vous connecter au compte windfrance de test, utilisez les identifiants suivants :<br/>` +
      `E-mail : test@windmorbihan.com - Mot de passe : TestWindFrance25</strong></p>` +
      `<button type="button" class="configure_spot" onclick="wm.dismissMockAccount()">Je me connecte</button>`
    MicroModal.show('info_spot_modal', {disableScroll: true});
  } else {

  }
}

export function validateUserProfile() {
  const usrProfile = document.querySelector("#user_profile"), choices = usrProfile.querySelectorAll(".choice_field");
  let totalAnswers = 0;
  for (const choice of choices) {
    const maxAnswers = parseInt(choice.getAttribute("data-max")),
      selectedAnswers = choice.querySelectorAll("input[type='checkbox']:checked");
    totalAnswers += selectedAnswers.length;
    if (maxAnswers < selectedAnswers.length) {
      selectedAnswers[selectedAnswers.length - 1].setCustomValidity(`Veuillez sélectionner au maximum ${maxAnswers} choix`);
    } else {
      for (const a of choice.querySelectorAll("input[type='checkbox']")) {
        a.setCustomValidity('');
      }
    }
  }
  console.debug('totalAnswers: ' + totalAnswers.toString());
  if (totalAnswers === 0) {
    choices[0].querySelector("input[type='checkbox']").setCustomValidity('Veuillez sélectionner au moins une pratique (loisir ou professionnelle)')
  } else {
    choices[0].querySelector("input[type='checkbox']").setCustomValidity('');
  }
}

export function dismissMockAccount() {
  MicroModal.close('info_spot_modal');
  MicroModal.show('form_modal', {disableScroll: true});
  document.querySelector("#form_modal .modal__footer > button:first-child").click();
  document.querySelector("#wm_sign_in_form input[type='email']").value = 'test@windmorbihan.com';
  document.querySelector("#wm_sign_in_form input[type='password']").value = 'TestWindFrance25';
}

export function mockSignIn() {
  if (document.querySelector("#wm_sign_in_form input[type='email']").value === 'test@windmorbihan.com' &&
    document.querySelector("#wm_sign_in_form input[type='password']").value === 'TestWindFrance25') {
    if (!localStorage.getItem('windUser')) {
      saveUserProfile(defaultUserProfile());
    }
    signInUser();
    MicroModal.close('form_modal');
    document.querySelector("#info_spot_modal_title").innerHTML = `Connexion réussie`;
    document.querySelector("#info_spot_modal_content").innerHTML = `<p>Bienvenue sur votre compte windfrance. ` +
      `Pour commencer, nous vous invitons à suivre une rapide présentation sur la configuration de vos spots de pratique :</p>` +
      `<div class="guided_tour"><button type="button" onclick="wm.startSpotsTour()">Démarrer la visite guidée</button></div>`;
    MicroModal.show('info_spot_modal', {disableScroll: true});
  } else {
    console.error("login attempt failed");
  }
}

export function signInUser() {
  const userSpots = getUserProfile().spots;
  document.querySelector("#account_spots button[data-spot-index='1'] strong").innerHTML = userSpots[0].ref;
  document.querySelector("#account_spots button[data-spot-index='2'] strong").innerHTML = userSpots[1].ref;
  document.querySelector("#account_spots button[data-spot-index='3'] strong").innerHTML = userSpots[2].ref;
  document.querySelector("#account_spots").classList.remove('hidden');
  document.querySelector("#wind_france_top").classList.add('hidden');
}

export function startSpotsTour() {
  MicroModal.close('info_spot_modal');
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      scrollTo: true
    }
  });
  tour.addStep({
    id: 'intro-step',
    text: 'Cette visite interactive va vous guider dans la découverte des fonctions de personnalisation de vos spots.',
    buttons: [
      {
        text: 'Démarrer',
        action: tour.next
      }
    ]
  });
  tour.addStep({
    id: 'menu-spots-step',
    text: 'Pour commencer, cliquez sur votre menu <strong>mes spots</strong>.',
    attachTo: {element: '#account_spots > button:first-child', on: 'bottom'},
    advanceOn: { selector: '#account_spots', event: 'click' }
  });
  tour.addStep({
    id: 'edit-spots-step',
    text: 'Cliquez ensuite sur le lien de configuration de vos spots.',
    scrollTo: false,
    attachTo: {element: '#account_spots > div > button:last-child', on: 'bottom'},
    advanceOn: { selector: '#account_spots > div > button:last-child', event: 'click' }
  });
  tour.addStep({
    id: 'select-edit-spot',
    text: "Dans la fenêtre qui s'ouvre, sélectionnez le spot que vous souhaitez personnaliser : nous allons ici personnaliser le spot 1 pour commencer.",
    attachTo: {element: '#spots_modal_content p + button.configure_spot', on: 'top'},
    advanceOn: { selector: '#spots_modal_content p + button.configure_spot', event: 'click' }
  });

  tour.start();
}

export function startEditSpotTour() {
  MicroModal.close('edit_spot_modal');
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      floatingUIOptions: {
        middleware: [offset(5)]
      }
    }
  });
  tour.addStep({
    id: 'intro-step',
    text: "Chaque spot peut être personnalisé pour afficher les données du site qui sont importantes pour vous. Un spot fonctionne comme un marque-page qui vous permet d'accéder rapidement à vos informations." ,
    buttons: [
      {
        text: 'Démarrer la personnalisation',
        action: tour.next
      }
    ]
  });
  tour.addStep({
    id: 'zoom-step',
    text: "Pour commencer cette visite guidée, nous allons positionner la carte sur une zone d'intérêt de notre choix : par exemple, nous allons nous positionner autour de Belle Île.",
    buttons: [
      {
        text: 'Etape suivante',
        action: function() {
          map.instance.setView(new L.LatLng(47.3095, -3.084), 11.5);
          tour.next();
        }
      }
    ]
  });
  tour.addStep({
    id: 'sensor-step',
    text: 'Pour continuer, nous allons sélectionner un capteur de vent sur la carte. Cliquez sur le capteur de Belle Île pour le sélectionner.',
    attachTo: {element: '#sensor_56009001', on: 'bottom'},
    advanceOn: { selector: '#sensor_56009001', event: 'click' }
  });
  tour.addStep({
    id: 'layer-step',
    text: 'Nous allons ensuite activer un calque : cliquez sur le bouton activant le calque des marégraphes en surbrillance sur la gauche.',
    attachTo: {element: '#map_layers #tide', on: 'top'},
    advanceOn: {selector: '#map_layers #tide', event: 'click'}
  });
  tour.addStep({
    id: 'tide-step',
    text: "Parmi les marégraphes que comporte le calque, nous allons retenir celui de notre zone d'intérêt, à savoir Le Palais. Sélectionnez ce marégraphe afin de la rattacher à votre spot.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, 800, "one");
      });
    },
    attachTo: {element: ".tide_spot a[title='Le Palais']", on: 'bottom'},
    advanceOn: { selector: ".tide_spot a[title='Le Palais']", event: 'click' }
  });
  tour.addStep({
    id: 'fc-step',
    text: "Pour compléter le spot, nous allons ensuite afficher des prévisions de vent. Pour cela, activez le calque de prévisions du vent en surbrillance sur la gauche.",
    attachTo: {element: '#map_layers #wind_fc', on: 'top'},
    advanceOn: {selector: '#map_layers #wind_fc', event: 'click'}
  });
  tour.addStep({
    id: 'fc-point-step',
    text: "À partir des prévisions de vent sur la zone, nous allons afficher les valeurs de prévisions prévues sur un point précis. Pour cela, cliquez sur un point de votre choix dans la zone en surbrillance : il sera ainsi ajouté à votre spot.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        document.querySelector("#particles_wrapper").insertAdjacentHTML('beforeend', '<div id="fc-point-step-overlay"></div>');
        resolve();
      });
    },
    attachTo: {element: '#fc-point-step-overlay', on: 'top'},
    advanceOn: {selector: '#markers_layer', event: 'click'}
  });
  tour.addStep({
    id: 'weather-step',
    text: "Pour finaliser la configuration du spot, nous allons ajouter 2 météogrammes couvrant notre zone d'intérêt. Pour cela, activez le calque météo en surbrillance sur la gauche.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, 800, "one");
      });
    },
    attachTo: {element: '#map_layers #weather_fc', on: 'top'},
    advanceOn: {selector: '#map_layers #weather_fc', event: 'click'}
  });
  tour.addStep({
    id: 'poi-step-1',
    text: "Sélectionnez tout d'abord le météogramme <strong>Donnant</strong> pour l'ajouter au spot.",
    beforeShowPromise: function() {
      return new Promise((resolve, reject) => {
        setTimeout(resolve, 800, "one");
      });
    },
    attachTo: {element: '#poi_donnant', on: 'top'},
    advanceOn: {selector: '#poi_donnant', event: 'click'}
  });
  tour.addStep({
    id: 'poi-step-2',
    text: "Sélectionnez ensuite le météogramme <strong>Le Palais</strong> pour l'ajouter au spot. Lorsque vous associez plusieurs météogrammes à votre spot, celui sélectionné en premier sera affiché automatiquement (ici celui de Donnant).",
    attachTo: {element: '#poi_le-palais', on: 'top'},
    advanceOn: {selector: '#poi_le-palais', event: 'click'}
  });
  tour.addStep({
    id: 'rename-step',
    text: "Nous arrivons au bout de cette visite guidée, notre spot recense désormais les informations que nous souhaitions lui associer. Pour sauvegarder votre spot tel que vous l'avez configuré, utilisez le formulaire sur la gauche pour lui attribuer un nom (3 caractères maximum, \"BI\" par exemple pour Belle-Île) puis utilisez le bouton <strong>Enregistrer</strong>.",
    attachTo: {element: '#edit_spot_controls', on: 'left'},
    advanceOn: {selector: '#save_current_spot', event: 'click'}
  });
  tour.addStep({
    id: 'other-data-step',
    text: "Pour la configuration de vos spots, vous pouvez réitérer les étapes abordées lors de cette visite guidée pour toutes les données présentes sur le site :<br/>- observations vent, houle, température<br/>- prévisions vent, vagues<br/>- prévisions pluie via carte radar<br/>- météogrammes, webcams, marégraphes",
    buttons: [
      {
        text: 'Etape suivante',
        action: tour.next
      }
    ]
  });
  tour.addStep({
    id: 'home-step',
    text: "À chaque instant, vous pouvez interrompre la personnalisation en cliquant sur le bouton Annuler ou sur le logo windmorbihan en haut de votre écran.<br/>Merci d'utiliser windmorbihan !",
    buttons: [
      {
        text: 'Terminer la visite',
        action: tour.complete
      }
    ]
  });

  tour.start();
}

function pinnedElements(selector) {
  const pinnedElts= document.querySelectorAll(`g.zoom_wrapper ${selector}.edit_pinned`),
    refs = [];
  for (const el of pinnedElts) {
    if (el.id) {
      refs.push(el.id.split('_')[1]);
    } else {
      refs.push(el.querySelector("a").getAttribute('data-href'));
    }
  }
  return refs;
}

function loadUserSpot(spotIndex, editMode) {
  const userSpot = getUserProfile().spots[spotIndex - 1], spotRef = userSpot?.ref;
  router.navigate(`/profil/test-wind/spots/${spotRef}${editMode ? '?edit=true' : ''}`);
}

function defaultUserSpot(ref) {
  return {
    ref: ref,
    mapCenter: [...config.mapCenter],
    mapZoom: config.mapZoom,
    bgLayers: ['wm'],
    dataLayers: ['wind', 'waves'],
    point: null,
    pois: [],
    webcams: [],
    tideGauges: [],
    windSensors: [],
    wavesSensors: [],
    tempSensors: []
  }
}

function getUserProfile() {
  const storedProfile = localStorage.getItem('windUser');
  return storedProfile ? JSON.parse(localStorage.getItem('windUser')) : defaultUserProfile();
}

function saveUserProfile(profileData) {
  console.debug('saving user profile: ' + JSON.stringify(profileData));
  localStorage.setItem('windUser', stringifySafe(profileData));
}

function defaultUserProfile() {
  return {
    email: 'test@windmorbihan.com',
    spots: [defaultUserSpot('1'), defaultUserSpot('2'), defaultUserSpot('3')]
  }
}

function stringifySafe(obj) {
  const seen = new WeakSet();
  return JSON.stringify(obj, (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  });
}
